import React from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { useLocation } from "react-router-dom";

export const MainLayout = ({ 
  children, 
  appName, 
  menuItems = [], 
  showNavbar = true, 
  showFooter = true,
  className = ""
}) => {
  const location = useLocation();
  const isAuthPage = ["/login", "/register", "/verify", "/forgot-password", "/lupapassword"].includes(
    location.pathname.toLowerCase()
  );

  const displayNavbar = showNavbar && !isAuthPage;
  const displayFooter = showFooter && !isAuthPage;

  return (
    <div className={`flex flex-col min-h-screen ${className}`}>
      {displayNavbar && <Navbar appName={appName} menuItems={menuItems} />}
      
      <main className={`flex-grow ${displayNavbar && location.pathname !== "/" ? "pt-12" : ""}`}>
        {children}
      </main>

      {displayFooter && <Footer />}
    </div>
  );
};
